import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Space, Typography, Row, Col } from 'antd';
// import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { useRecoverPassword, validatePassword } from 'all-in-one-shared-api';
// import { InfoCircleOutlined } from '@ant-design/icons';
import StyledCheckbox from '../registration/components/StyledCheckbox';
// import forgotIcon from 'assets/images/reset-icon.svg';
// import { VStack } from 'components';
// import { loginIdRegex } from 'utils/regex';
// import generateKey from 'utils/generateKey';
import eyeOpen from 'assets/images/Mask.svg';
import eyeClose from 'assets/images/redMask.svg';
import { useContext, useState, useCallback } from 'react';
import { ForgotPasswordData } from './forgotPasswordData';
import PolicyAndMemberIdModal from './PolicyAndMemberIdModal';
// import { Wrapper } from './styledComponents';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { RegistrationFlowContext } from 'contexts/registration';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { useKeycloakReady } from 'hooks';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { osName, osVersion } from 'react-device-detect';
import generateKey from 'utils/generateKey';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { localStorageService } from 'utils/LocalStorageService';
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

interface LocationState {
  otpCode: string;
}
function ForgotPasswordResetPage() {
  const location = useLocation();
  const { otpCode } = (location.state as LocationState) ?? {};
  const [key, setKey] = useState('generateKey');
  const [showErrorDesc, setShowErrorDesc] = useState('');
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useContext(RegistrationFlowContext);
  const { t, i18n } = useTranslation();
  const [formDataState, setFormDataState] = React.useState<ForgotPasswordData>({
    email: '',
  });
  const initialValues = useRegistrationStateQuery();
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  // const [forgotPasswordWithLoginKey, setForgotPasswordWithLoginKey] = React.useState<string>('');
  // const [forgotPasswordWithMemberIdKey, setForgotPasswordWithMemberIdKey] = React.useState<string>('');
  const [snackbarMessage] = React.useState('');
  const [isShowError, setShowError] = React.useState(false);
  const [errmessage, setErrmessage] = useState<string | null>(null);
  // const [method, setMethod] = React.useState('loginId');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const { tokenParsed } = useKeycloakReady();
  const from: string = tokenParsed?.ebClientKey != '' ? '/home' : '/LIHome';
  const errorMapping: Record<string, string> = {
    'auth.recovery.invalid': 'forgetLoginId.error.informationInvalid',
  };

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);

  const { data, shouldFetch, error } = useRecoverPassword(
    key,
    localStorageService.get('deviceId') ?? '',
    state.selfDefinedLoginId || initialValues.selfDefinedLoginId || '',
    formDataState.confirmPassword ?? '',
    otpCode,
    'WEB',
    state.email || initialValues.email,
    state.mobile || initialValues.mobile,
    state.countryCode || initialValues.countryCode,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: () => {
        // setStartLoading(false);
      },
      onError: (error) => {
        if (error) {
          shouldFetch(false);
          setIsLoading(false);
          // const apiError = error as ApiFetcherError;
          // setErrorMsg(apiError.code ? apiError.code : error.message);
          setShowErrorDesc(error.code);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrmessage(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const [password, setPassword] = useState('');
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };
  const handleToggleVisibility = () => {
    setVisible(!visible);
  };
  const handleToggleVisibility2 = () => {
    setVisible2(!visible2);
  };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (error) {
      // const errorMessage = setErrorCodeFun(error.code ?? '', i18n.language);
      setErrmessage(error.message);
    }
  }, [error, shouldFetch]);

  useEffect(() => {
    const errorMessage = setErrorCodeFun(showErrorDesc ?? '', i18n.language);
    setErrmessage(errorMessage);
  }, [i18n.language, showErrorDesc]);

  const handleCloseSnackbar = () => {
    setShowError(false);
  };

  // const onValidateSuccessful = React.useCallback(
  //   (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {

  //     // setLoading(true);
  //     // setApiError(null);
  //     // navigation.navigate('RegistrationSubmissionWithLifeInsuranceScreen');
  //     event && event.preventDefault();
  //     // dispatch({ type: ActionType.UpdateFormData, payload: data });
  //   },
  //   [shouldFetch],
  // );

  const onFinish = () => {
    setKey(generateKey);
    shouldFetch(true);
    setIsLoading(true);
    // navigate('/forgot/ForgotPasswordWithEmailPage'); //提交时注释掉
    // setFormDataState({
    //   password: values.password,
    //   confirmPassword: values.confirmPassword,
    // });

    // onValidateSuccessful(formDataState);
  };
  const username = state.selfDefinedLoginId || initialValues.selfDefinedLoginId || '';

  const loginWithRetry = useCallback(
    (username: string, password: string, maxAttempts: number) => {
      return new Promise<void>((resolve, reject) => {
        const keycloakLogin = async (attempt = 1) => {
          try {
            await keycloak.login({
              username,
              password,
              device: osName,
              deviceVersion: osVersion,
              deviceId: localStorageService.get('deviceId'),
              loginMethod: 'FP_LOGIN',
              loginPlatform: 'WEB',
            });
            resolve();
          } catch (error: unknown) {
            const errorMessage = error instanceof Error ? error.message : undefined;
            // console.log('loginWithRetry()->error from keycloak.login():', errorMessage);
            if ((errorMessage && !errorMessage.includes('auth error')) || attempt > maxAttempts) {
              console.log(error, 'HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHh');
              navigate('/login', { replace: true });
              reject(error);
            } else {
              setTimeout(() => keycloakLogin(attempt + 1), 500);
            }
          }
        };

        keycloakLogin();
      });
    },
    // eslint-disable-next-line
    [keycloak],
  );
  const startUsing = useCallback(async () => {
    await loginWithRetry(username, password, 2);
    // 使用 replace 代替 reset，来模拟重置历史记录
    localStorage.setItem('username', username);
    navigate(from, { replace: true });
  }, [username, password, from, navigate, loginWithRetry]);
  const isValid = formDataState.confirmPassword;
  // useEffect(() => {
  //   if (formDataState.confirmPassword) {
  //     shouldFetch(true);
  //   }
  // }, [formDataState, shouldFetch]);
  // const infoIcon = <InfoCircleOutlined onClick={showModal} style={{ cursor: 'pointer' }} />;
  useEffect(() => {
    if (data && !error) {
      startUsing();
    }
    shouldFetch(false);
    setIsLoading(false);
    //eslint-disable-next-line
  }, [data, error, navigate, shouldFetch]);
  const isLargeScreen = useMediaQuery({ minWidth: 768 }); // 根据屏幕宽度判断是否为大屏

  return (
    <ResponsiveContainer>
      {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#fff', fontWeight: '400' }}
      >
        {t('forgetPassword.title')}{' '}
      </Typography.Title>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        <Row
          justify="center"
          style={{
            width: isLargeScreen ? '618px' : '80%', // 大屏使用618px，小屏使用80%
          }}
          gutter={[16, { xs: 8, sm: 16, md: 24 }]}
        >
          {' '}
          {/* <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, width: '100%', border: 0 }}> */}
          <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
            {isShowError && (
              <Alert
                className="custom-alert"
                message={t(errorMapping[snackbarMessage])}
                type="error"
                closable
                onClose={handleCloseSnackbar}
                style={{
                  marginBottom: 16,
                  backgroundColor: 'red',
                  color: 'yellow',
                }}
              />
            )}
          </Col>
          <Col xs={24} md={24} style={{ display: 'flex' }}>
            <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
              {t('resetPassword.descriptionText')}
            </Typography.Text>
          </Col>
          <Col xs={24} md={24} style={{ display: 'flex' }}>
            <Space style={{ marginTop: 16, marginBottom: 16 }}>
              <Typography.Text style={{ color: '#752127', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('forgetPassword.mandatoryMsg')}
              </Typography.Text>
            </Space>
          </Col>
          {/* </Wrapper> */}
          <Form
            layout={'vertical'}
            requiredMark={false}
            onFinish={onFinish}
            form={form}
            validateTrigger={'onBlur'}
            style={{ width: '100%' }}
            onValuesChange={(changedValues) => {
              // 合并所有更改到 registrationState 中
              setFormDataState((prevState) => ({
                ...prevState, // 保留之前的状态
                ...changedValues, // 只更新 changedValues 中的字段
              }));
            }}
          >
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ fontWeight: 'normal', fontSize: '17px', color: '#752127' }}>
                    {t('resetPassword.passwordLabel')}
                  </span>
                }
                name="password"
                rules={[
                  { required: true, message: t('registration.error.required') },
                  () => ({
                    validator(_, value) {
                      const validationResult = validatePassword(value);

                      if (!value || validationResult.isValid) {
                        return Promise.resolve();
                      }

                      return Promise.reject(new Error(t('resetPassword.error.invalidPassword')));
                    },
                  }),
                ]}
              >
                <div style={{ position: 'relative' }}>
                  <Input
                    size="middle"
                    maxLength={12}
                    disabled={false}
                    placeholder={t('resetPassword.passwordPlaceholder')}
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #E5E5E5',
                      paddingLeft: 0,
                      // color: "white",
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      backgroundColor: 'transparent',
                    }}
                    onChange={handlePasswordChange}
                    type={visible ? 'text' : 'password'}
                    // placeholder={placeholder}
                  />
                  <img
                    src={visible ? eyeOpen : eyeClose}
                    alt="toggle visibility"
                    style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 10 }}
                    onClick={handleToggleVisibility}
                  />
                </div>
              </BoldLabelFormItem>
              <div style={{ marginBottom: 16 }}>
                <div>
                  <StyledCheckbox checked={password?.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password)}>
                    <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('forgetPassword.Minimumcharacters')}
                    </Typography.Text>
                  </StyledCheckbox>
                </div>
                <div>
                  <StyledCheckbox checked={/[A-Z]/.test(password) && /[a-z]/.test(password)}>
                    <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('forgetPassword.ContainsUppercase')}
                    </Typography.Text>
                  </StyledCheckbox>
                </div>
                <div>
                  <StyledCheckbox checked={/\d/.test(password)}>
                    <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('forgetPassword.ContainsDigit')}
                    </Typography.Text>
                  </StyledCheckbox>
                </div>
              </div>
            </Col>
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px' }}>
                    {t('resetPassword.confirmPasswordLabel') + '*'}
                  </span>
                }
                name="confirmPassword"
                dependencies={['password']}
                rules={[
                  { required: true, message: t('registration.error.required') },
                  () => ({
                    validator(_, value) {
                      console.log('value', value, 'getFieldValue', password);
                      if (!value || password === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                    },
                  }),
                ]}
              >
                <div style={{ position: 'relative' }}>
                  <Input
                    size="middle"
                    maxLength={12}
                    placeholder={t('resetPassword.confirmPasswordPlaceholder')}
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #E5E5E5',
                      // color: "white",
                      fontSize: '20px',
                      paddingLeft: 0,
                      fontFamily: 'Roboto400',
                      backgroundColor: 'transparent',
                    }}
                    type={visible2 ? 'text' : 'password'}
                    // placeholder={placeholder}
                  />
                  <img
                    src={visible2 ? eyeOpen : eyeClose}
                    alt="toggle visibility"
                    style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 10 }}
                    onClick={handleToggleVisibility2}
                  />
                </div>
              </BoldLabelFormItem>
            </Col>
            {/* )} */}

            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  // backgroundColor: 'pink',
                }}
              >
                <BoldLabelFormItem style={{ width: isLargeScreen ? '428px' : '100%', marginBottom: '40px' }}>
                  {/* <Row gutter={[16, { xs: 24, sm: 24, md: 24 }]}> */}
                  {errmessage && (
                    <Alert
                      className="custom-alert"
                      message={errmessage}
                      type="error"
                      style={{
                        marginBottom: 16,
                        border: 'none',
                      }}
                    />
                  )}
                  <Button
                    block
                    type="primary"
                    // loading={
                    //   (isLoading && isCheckExistingMemberLoading) || (isLoadingvalidate && isCheckExistingMemberLoading)
                    // }
                    loading={isLoading}
                    disabled={!isValid}
                    style={{
                      marginTop: 24,
                      fontFamily: 'Roboto500',
                      fontSize: '20px',
                      height: '56px',
                      width: '100%',
                    }}
                    size="large"
                    htmlType="submit"
                  >
                    {t('common.submit')}
                  </Button>
                  {/* </Row> */}
                </BoldLabelFormItem>
              </div>
            </Col>
          </Form>
        </Row>
      </div>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default ForgotPasswordResetPage;
